import { customAlphabet } from 'nanoid';
import dictionary from 'nanoid-dictionary';
import Haikunator from 'haikunator';


export function generateName(options={}) {
  const haikunator = new Haikunator();
  if (options) return haikunator.haikunate(options);
  return haikunator.haikunate();
}

export function uniqueId(prefix='', length=10) {
  const generator = customAlphabet(dictionary.alphanumeric, length);
  let id = generator();
  if (prefix) id = `${prefix}${id}`;
  return id;
}
